import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { appliquerTheme, suivreSysteme } from './services/theme';

// Avant le premier rendu : sinon la page s'affiche en clair puis bascule.
appliquerTheme();
suivreSysteme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
